import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const projectAnimation = () => {
    /* Variables */
    let swiper;
    let observers = [];
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: [[]]
    };

    function init () {
    }

    function start () {
        introAnimation();

        // Navigation
        const elNav = document.querySelector('.js-project-navigation');
        if (elNav) {
            gsap.from(elNav, {
                yPercent: 30,
                ease: 'none',
                scrollTrigger: {
                    trigger: document.body,
                    start: `bottom-=${elNav.offsetHeight}px bottom`,
                    end: 'bottom bottom',
                    scrub: true
                }
            });
        }
    }

    function introAnimation () {
        if (!document.querySelector('.c-project-header__title-content')) return;
        
        const introTl = gsap.timeline();
        introTl.set('.c-project-header__title-content', {
            opacity: 1,
            yPercent: 100
        });
        introTl.to('.c-project-header__title-content', 0.8, {
            yPercent: 0,
            ease: 'power1.out'
        });
        introTl.to('[data-anim="project-intro"]', 0.7, {
            opacity: 1,
            ease: 'power1.out'
        }, '-=0.3');
        introTl.from('.c-project-content > *', 0.7, {
            opacity: 0,
            ease: 'power1.out'
        }, '-=0.3');
    }

    return {
        init,
        start
    }
};

export default projectAnimation;



// WEBPACK FOOTER //
// ./web/assets/src/js/modules/project-animations.js